export default function getScriptParams(url: string): URLSearchParams | null {
    let script = document.querySelector(`script[src*="${url}"]`) as HTMLScriptElement;

    if (!script) {
        const urlMini = "fs-recommendations-init.min.js"
        script = document.querySelector(`script[src*="${urlMini}"]`) as HTMLScriptElement;
    }

    return script ? new URL(script.src).searchParams : null
}